import { WorkflowSelectV2 } from '@frontend/workflow/select';
import { WorkflowType } from '@frontend/workflow/types';

export interface TransactionWorkflowFieldProps {
    onChange: (value: string | null) => void;
    value: string | null;
    disabled?: boolean;
    className?: string;
    label?: React.ReactNode;
    required?: boolean;
    options?: string[];
}

export const TransactionWorkflowField = (props: TransactionWorkflowFieldProps) => {
    return (
        <WorkflowSelectV2
            {...props}
            queryParams={{ type: WorkflowType.TRANSACTION }}
            isClearable
        />
    );
};
